import { render, staticRenderFns } from "./businesDepartment.vue?vue&type=template&id=f581f026&scoped=true"
import script from "./businesDepartment.vue?vue&type=script&lang=js"
export * from "./businesDepartment.vue?vue&type=script&lang=js"
import style0 from "./businesDepartment.vue?vue&type=style&index=0&id=f581f026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f581f026",
  null
  
)

export default component.exports